export default [
  {
    path: "/zczxList",
    name: "zczxList",
    component: () => import("./zczx/zczxList.vue")
  },
  {
    path: "/zczxDetail",
    name: "zczxDetail",
    component: () => import("./zczx/zczxDetail.vue")
  },
  {
    path: "/newsList",
    name: "newsList",
    component: () => import("./news/list.vue")
  },
  {
    path: "/newsDetail",
    name: "newsDetail",
    component: () => import("./news/detail.vue")
  },
  {
    path: "/studyList",
    name: "studyList",
    component: () => import("./study/list.vue")
  },
  {
    path: "/studyDetail",
    name: "studyDetail",
    component: () => import("./study/detail.vue")
  }
];



// WEBPACK FOOTER //
// ./src/views/policyALL/router.js